/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import BoardScore from 'solis/logic/board/score';

import Hex from 'solis/claude/element/peak/hex';


const PEAK_COUNT = 5;
const HEX_SIZE = 26;


export default ({ board }) =>
{
  const peaks = new BoardScore(board).getZonesByAuthority().slice(0, PEAK_COUNT);

  return (
    <Flex gap = '1' align = 'center'>
      {peaks.map(({ zone, authority }) => <Hex key = {zone.getAbsoluteHex().toString()} value = {authority} size = {HEX_SIZE} />)}
    </Flex>
  );
};
